var _g, _g2, _g3, _g4, _g5, _g6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarsBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2405,
    height: 398,
    viewBox: "0 0 2405 398",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1853.89 97.4473L1862.05 194.122C1864.07 218.12 1883.11 237.159 1907.11 239.183L2003.78 247.336L1907.11 255.49C1883.11 257.514 1864.07 276.553 1862.05 300.55L1853.89 397.225L1845.74 300.55C1843.72 276.552 1824.68 257.514 1800.68 255.49L1704 247.336L1800.68 239.183C1824.68 237.159 1843.72 218.12 1845.74 194.122L1853.89 97.4473Z",
    fill: "url(#paint0_linear_4638_23863)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1853.89 397.225L1845.73 300.55C1843.71 276.552 1824.67 257.513 1800.67 255.489L1704 247.336L1812.55 250.517L-nan -nanL-nan -nanL1812.55 250.517C1833.25 251.355 1849.82 267.977 1850.6 288.68L1850.71 291.643L1853.89 397.225Z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M550.795 97.4473L542.641 194.122C540.617 218.12 521.579 237.159 497.581 239.183L400.906 247.336L497.581 255.49C521.579 257.514 540.617 276.553 542.641 300.55L550.795 397.225L558.949 300.55C560.973 276.552 580.011 257.514 604.009 255.49L700.684 247.336L604.009 239.183C580.011 237.159 560.973 218.12 558.949 194.122L550.795 97.4473Z",
    fill: "url(#paint1_linear_4638_23863)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M550.798 393.661L558.952 296.986C560.976 272.988 580.015 253.95 604.012 251.926L700.687 243.772L592.138 246.954L-nan -nanL-nan -nanL592.138 246.954C571.438 247.792 554.866 264.414 554.091 285.116L553.98 288.08L550.798 393.661Z",
    fill: "#C4C4C4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M2295.08 138.325L2301.01 208.635C2302.49 226.088 2316.33 239.935 2333.79 241.407L2404.1 247.337L2333.79 253.267C2316.33 254.739 2302.49 268.585 2301.01 286.038L2295.08 356.348L2289.15 286.038C2287.68 268.585 2273.84 254.739 2256.38 253.267L2186.07 247.337L2256.38 241.407C2273.84 239.935 2287.68 226.088 2289.15 208.635L2295.08 138.325Z",
    fill: "url(#paint2_linear_4638_23863)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M2295.08 356.349L2289.15 286.039C2287.68 268.585 2273.84 254.739 2256.38 253.267L2186.07 247.337L2265.02 249.651L-nan -nanL-nan -nanL2265.02 249.651C2280.07 250.26 2292.13 262.349 2292.69 277.406L2292.77 279.561L2295.08 356.349Z",
    fill: "#C4C4C4"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2068.01 0L2068.01 102.198",
    stroke: "white",
    strokeWidth: 2,
    strokeDasharray: "4 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2119.11 51.0996L2016.91 51.0996",
    stroke: "white",
    strokeWidth: 2,
    strokeDasharray: "4 6"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.761 0L309.761 102.198",
    stroke: "white",
    strokeWidth: 2,
    strokeDasharray: "4 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.86 51.0996L258.662 51.0996",
    stroke: "white",
    strokeWidth: 2,
    strokeDasharray: "4 6"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M109.603 138.325L103.673 208.635C102.201 226.088 88.3543 239.935 70.9011 241.407L0.591154 247.337L70.9012 253.267C88.3543 254.739 102.201 268.585 103.673 286.038L109.603 356.348L115.533 286.038C117.005 268.585 130.851 254.739 148.304 253.267L218.614 247.337L148.304 241.407C130.851 239.935 117.005 226.088 115.533 208.635L109.603 138.325Z",
    fill: "url(#paint3_linear_4638_23863)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M109.605 356.349L115.535 286.039C117.007 268.585 130.853 254.739 148.307 253.267L218.617 247.337L139.671 249.651L-nan -nanL-nan -nanL139.671 249.651C124.616 250.26 112.563 262.349 112 277.406L111.919 279.561L109.605 356.349Z",
    fill: "#C4C4C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4638_23863",
    x1: 1752.6,
    y1: 154.24,
    x2: 1961.28,
    y2: 416.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121317"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4638_23863",
    x1: 652.087,
    y1: 154.24,
    x2: 443.405,
    y2: 416.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121317"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4638_23863",
    x1: 2221.42,
    y1: 179.629,
    x2: 2373.19,
    y2: 370.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121317"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4638_23863",
    x1: 183.27,
    y1: 179.629,
    x2: 31.5002,
    y2: 370.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121317"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsBg);
export default __webpack_public_path__ + "static/media/stars-bg.2716c150de5ce6811866b2ebc5c2b3ac.svg";
export { ForwardRef as ReactComponent };